import React, { useContext } from 'react';
import { Box, Grid } from '@mui/material';
import DocumentPropertiesGroup from './DocumentPropertiesGroup';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import PropTypes from 'prop-types';
import { RightsContext } from 'providers/RightsContext';
import { Card, Button } from '@totalsoft/rocket-ui';

function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach(item => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}

const DocumentPropertiesCard = ({ properties, onPropertyChange, loadPropertyDetails, t, onSaveProperties, isDirty, readOnly, isValid }) => {
  const groupedProperties = groupBy(properties, x => x.category);

  const { folderDocumentPropertiesWrite, offerDocumentPropertiesWrite, isImage, readOnlyFull } = useContext(RightsContext);

  const hasRightToEditProperties = offerDocumentPropertiesWrite ? offerDocumentPropertiesWrite : folderDocumentPropertiesWrite;

  return (
    <Card icon={AccountTreeIcon} title={t('Document.DocumentProperties.Title')}>
      <Grid container spacing={2}>
        {Array.from(groupedProperties.keys()).map((property, index) => (
          <Grid item xs={12} key={index}>
            <Card key={'document_properties_card'} title={property}>
              <DocumentPropertiesGroup
                key={index}
                properties={groupedProperties.get(property)}
                onPropertyChange={onPropertyChange}
                loadPropertyDetails={loadPropertyDetails}
                readOnly={
                  !!readOnly ||
                  !!readOnlyFull ||
                  (offerDocumentPropertiesWrite ? !offerDocumentPropertiesWrite : !folderDocumentPropertiesWrite)
                }
              />
            </Card>
          </Grid>
        ))}
      </Grid>
      {!isImage && (
        <Box mt={2}>
          <Button onClick={onSaveProperties} disabled={hasRightToEditProperties ? !isDirty || readOnly || !isValid : false}>
            {t('Save')}
          </Button>
        </Box>
      )}
    </Card>
  );
};

DocumentPropertiesCard.propTypes = {
  t: PropTypes.func.isRequired,
  properties: PropTypes.array.isRequired,
  loadPropertyDetails: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  onSaveProperties: PropTypes.func.isRequired,
  isDirty: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired
};

export default compose(withTranslation())(DocumentPropertiesCard);
